import { takeLatest } from 'redux-saga/effects';

import * as searchPageActionTypes from 'store/modules/searchPage/actionTypes';
import { search } from './utils';

export default function* listenSearch() {
  yield takeLatest([searchPageActionTypes.SEARCH], search);
}
